<template>
    <div class="newsletter-content mb-40">
        <h1 class="mb-20">Subscribe to our Newsletter</h1>
        <form>
            <div class="input-group position-relative">
                <font-awesome-icon class="icon-shape" :icon="['fas', 'fa-paper-plane']" />
                <input type="email" placeholder="Enter your email address">
                <button type="button">Submit</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'news-letter'
}
</script>